import { useMutation, useQueryClient } from "@tanstack/react-query";

import { useDomainServices } from "@/providers/DomainServices";
import { ErrorMonitoringService } from "@/shared/services/ErrorMonitoringService";

import { shouldReportBoardError } from "../boardFailures";

import { cacheCreatedBoard } from "./refreshBoardQueries";

/**
 * Save a board draft under a name, resolving with the board the platform
 * stored. That board has an id of its own, and the draft is gone from this
 * browser, so a caller showing the draft goes to the stored board's address.
 */
export function useSaveBoardDraft() {
  const { boardService } = useDomainServices();
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({
      boardId,
      orgId,
      name,
    }: {
      boardId: string;
      orgId: string;
      name: string;
    }) => boardService.saveBoardDraft(boardId, name, orgId),
    onSuccess: (record) => {
      cacheCreatedBoard(queryClient, record);
    },
    onError: (error) => {
      if (shouldReportBoardError(error)) {
        ErrorMonitoringService.captureError(error);
      }
    },
  });
}
